export const number_format = (number, defaultValue = '0') => {
	if (typeof(number) !== 'undefined') {
		return Number(number).toLocaleString()
	} else {
		return defaultValue
	}

}

export const isUrl = (str) => {
	return ("" + str).match(/^https?:\/\/.+\..+/) !== null
}

export const isEmail = (str) => {
	return ("" + str).match(/[^@]+@[^@]+\.[^@]+/) !== null
}

export const isMailto = (str) => {
	return ("" + str).match(/mailto:[^@]+@[^@]+\.[^@]+/) !== null
}

export const url_format = (str) => {
	return ("" + str).replace(/^https?:\/\//, '')
}

export const ipMasking = (str) => {
    return str.replace(/^([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/, (a, b, c, d, e) => {
        return `${b}.${c}.***.${e}`
    });
}

export const isValidDomainHost = (domain) => {

  const parts = (""+domain).split('.')
  if (parts.length <= 1) return false

  const tld = parts.pop()
  const tldRegex = /^(?:xn--)?[a-zA-Z0-9]+$/gi

  if (!tldRegex.test(tld)) return false
  if (tld.length <= 1) return false

  return parts.every(function (host) {
    const hostRegex = /^(?!:\/\/)([a-zA-Z0-9]+|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])$/gi;
    return hostRegex.test(host)
  })

}
